$(function () {
  animateDelay();
  pageLoader();
  otherSlider();
  // vidBg();
});

function pageLoader() {
  if ($(".page-loader").length) {
    try {
      kvSlider();
      setTimeout(function () {
        $(".page-loader").fadeOut(400);
        animateTrigger();
      }, 600);
    } catch (err) {
      console.log(err.message);
    }
  }
}

function animateTrigger() {
  if ($(".animTrigger").length) {
    try {
      var observer = new IntersectionObserver(
        function (entries, observer) {
          $.each(entries, function (i, entry) {
            if (entry.isIntersecting) {
              $(entry.target).addClass("anim-is-active");
              observer.unobserve(entry.target); // remove if you want repeat
            }
          });
        },
        {
          threshold: 0.2,
        },
      );

      $(".animTrigger").each(function () {
        observer.observe(this);
      });
    } catch (err) {
      console.log(err.message);
    }
  }
}

function animateDelay() {
  if ($(".animTarget").length) {
    try {
      $(".animTarget").each(function () {
        var delay = $(this).attr("anim-data-delay");

        if (delay && !isNaN(delay)) {
          var seconds = parseInt(delay, 10) / 1000;
          $(this).css("animation-delay", seconds + "s");
        }
      });
    } catch (err) {
      console.log(err.message);
    }
  }
}

function vidBg() {
  if ($(".gift-set-vid").length) {
    try {
      $(".gift-set-vid").each(function () {
        var $vid = $(this);
        var src = $vid.data("video-src");

        if (!$vid.find("iframe").length) {
          var iframe = $("<iframe>", {
            // width: 994,
            // height: 559,
            src: src,
            frameborder: 0,
            allow: "autoplay; fullscreen",
            allowfullscreen: true,
          });
          $vid.append(iframe);
        }
      });
    } catch (err) {
      console.log(err.message);
    }
  }

  if ($("kv-slide-vid-bg").length) {
    try {
      $("kv-slide-vid-bg").each(function () {
        var $vid = $(this);
        var src = $vid.data("video-src");

        if (!$vid.find("iframe").length) {
          var iframe = $("<iframe>", {
            // width: 994,
            // height: 559,
            src: src,
            frameborder: 0,
            allow: "autoplay; fullscreen",
            allowfullscreen: true,
          });
          $vid.append(iframe);
        }
      });
    } catch (err) {
      console.log(err.message);
    }
  }
}

function kvSlider() {
  // KV Slider
  if ($(".kv-slider").length) {
    try {
      $(".kv-slider")
        .on("init", function (event, slick) {
          // Add animation to first slide on load
          let $firstSlide = $(slick.$slides[0]);
          $firstSlide.addClass("is-animated");
        })
        .on("afterChange", function (event, slick, currentSlide) {
          // Add animation to new active slide after 2s delay
          let $currentSlide = $(slick.$slides[currentSlide]);
          $currentSlide.addClass("is-animated");
        })
        .on("beforeChange", function (event, slick, currentSlide) {
          // Remove animation from current slide before switching

          setTimeout(function () {
            $(slick.$slides[currentSlide]).removeClass("is-animated");
          }, 2000);
        })
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          speed: 900, // animation speed
          infinite: true,
          autoplay: true, // enable autoplay
          autoplaySpeed: 5000, // time between slides
          fade: true, // enable fade effect
          cssEase: "linear", // smoother fade
          pauseOnHover: false,
          pauseOnFocus: false,
          draggable: false, // optional (disable manual interaction)
          swipe: false,
        });
    } catch (err) {
      console.log(err.message);
    }
  }
}

function otherSlider() {
  // Watch Slider
  if ($(".watch-slider").length) {
    try {
      $(".watch-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        dots: false,
        speed: 500,
        centerPadding: "0",
        infinite: true,
        autoplay: false,
        autoplaySpeed: 2000,
        focusOnSelect: true,
        swipeToSlide: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
          {
            breakpoint: 751, // 750px and below
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: "100px", // small peek amount
              arrows: false,
              dots: false,
              infinite: true,
              speed: 500,
            },
          },
        ],
      });
      $(".color-picker button").on("click", function () {
        var slideIndex = $(this).data("slide");
        console.log("Button clicked, slide index: " + slideIndex);

        var prevIndex = $(this).prev("button").data("slide");
        console.log("Previous button index: " + prevIndex);

        $(".watch-slider").slick("slickGoTo", slideIndex);

        $(".color-picker button").removeClass("active");
        $(this).addClass("active");
      });
      $(".watch-slider").on(
        "afterChange",
        function (event, slick, currentSlide) {
          // normalize index (removes clone offset issue)
          let realIndex = currentSlide % slick.slideCount;
          $(".color-picker button").removeClass("active");
          $('.color-picker button[data-slide="' + realIndex + '"]').addClass(
            "active",
          );
        },
      );

      // start autoplay if in view
      const slider = document.querySelector(".watch-slider");
      if (slider) {
        let hasPlayed = false;
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !hasPlayed) {
                hasPlayed = true;
                $(".watch-slider").slick("slickPlay");
                //stop observing after first trigger
                observer.unobserve(slider);
              }
            });
          },
          {
            threshold: 0.5,
          },
        );
        observer.observe(slider);
      }
    } catch (err) {
      console.log(err.message);
    }
  }

  // Continous Slider
  if ($(".continous-slider").length) {
    try {
      $(".continous-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 6000,
        cssEase: "linear",
        waitForAnimate: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
          {
            breakpoint: 751, // 750px and below
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    } catch (err) {
      console.log(err.message);
    }
  }
}
